module.exports = __webpack_public_path__ + "assets/img/dzh-17.717fd4a9.jpg";